/**
 * Checks whether a given link is an external URL (starts with http:// or https://).
 * If true → open in a new browser tab.
 * If false → treat as an internal file path and handle with the in-app preview dialog.
 */
export const isExternalLink = (link: string | undefined | null): boolean => {
  if (!link) return false;
  return /^https?:\/\//i.test(link);
};

/**
 * Opens an external URL in a new tab or invokes the provided callback for internal paths.
 * @param link        The tugasLink / file path value
 * @param onFilePath  Callback to execute when the link is a local file path
 */
export const openLinkOrPreview = (
  link: string | undefined | null,
  onFilePath: () => void
): void => {
  if (!link) return;
  if (isExternalLink(link)) {
    window.open(link, "_blank", "noopener,noreferrer");
  } else {
    onFilePath();
  }
};
